import {MI} from "../init";
import {multi, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {getLanguage, madnes_get_json} from "../../framework/src/engine/madnes/madnes";
import AbstractSymbol from "../symbol/AbstractSymbol";
import {wintable_phaser} from "../../framework/src/engine/madnes/MadnesApp";

/**
 * @constructor
 */
export default function GameInfo() {

    /** @type {number} */
    this._slideDuration = 500;

    /** @type {ServerConfig} */
    this._serverConfig;

    /** @type {Array<MadnesGroup>}*/
    this._slidesGroups = [];

    /** @type {number} */
    this._pos = 0;

    /** @type {Object<string, MadnesObject>} */
    this._texts = {};

    /** @type {Array<MadnesObject>} */
    this._objects = [];

    /** @type {boolean} */
    this._locked = false;
};

/**
 * @param {ServerConfig} serverConfig
 */
GameInfo.prototype.init = function(serverConfig) {
    this._serverConfig = serverConfig;

    this._phaser = wintable_phaser;

    for(var i = 0; i < 3; i++) {
        this._slidesGroups.push(MI.addGroup("infotable_group_" + i, this._phaser));
    }
};

GameInfo.prototype._getBonusYPos = function(lang) {

    switch(lang) {
        case "cs": return 575;
        default : return 560;
    }
};

GameInfo.prototype.create = function() {

    this._objects[0] = MI.addImg(0, 0, "wintable");
    this._objects[1] = MI.addImg(0, 0, "info");
    this._objects[2] = MI.addImg(0, 0, "info");

    this._slidesGroups[0].add(this._objects[0]);
    this._slidesGroups[1].add(this._objects[1]);
    this._slidesGroups[2].add(this._objects[2]);

    var wild = MI.addImg(160, 355, "info_atlas").setFrameName("wild_info");

    var vPos = this._getBonusYPos(getLanguage());

    var star = MI.addImg(640 - 160, vPos, "info_atlas").setFrameName("star_info").setAnchor(0.5, 0.5);
    // var boomSpins1 = MI.addImg(640, vPos, "info_atlas").setFrameName("boom_spins_1").setAnchor(0.5, 0.5);
    var boomSpins2 = MI.addImg(640 + 160, vPos, "info_atlas").setFrameName("boom_spins_2").setAnchor(0.5, 0.5);

    this._objects.push(star);
    this._objects.push(wild);

    this._slidesGroups[1].add(wild);
    this._slidesGroups[2].add(star);
    // this._slidesGroups[2].add(boomSpins1);
    this._slidesGroups[2].add(boomSpins2);

    var txt = "";

    this._texts = {
        'symbol_Seven_4': MI.addBitmapText("font_wintable", 300, 175, txt, 80),
        'symbol_Seven_3': MI.addBitmapText("font_wintable", 290, 233, txt, 80),

        'symbol_Melon_4': MI.addBitmapText("font_wintable", 1024, 175, txt, 80), //MI.addBitmapText("font_wintable", 920, 80, txt, 80),
        'symbol_Melon_3': MI.addBitmapText("font_wintable", 1030, 233, txt, 80),

        'symbol_Grape_4':  MI.addBitmapText("font_wintable", 290, 365, txt, 80),
        'symbol_Grape_3':  MI.addBitmapText("font_wintable", 300, 423, txt, 80),

        'symbol_Plum_4':  MI.addBitmapText("font_wintable", 1030, 365, txt, 80),
        'symbol_Plum_3':  MI.addBitmapText("font_wintable", 1024, 423, txt, 80)
    };

    var keys = Object.keys(this._texts);

    for(var i = 0; i < keys.length; i++) {
        var key = keys[i];
        //this._texts[key].setTextShadow(0, 0, 'rgba(0,0,0,1)', 10);
        this._texts[key].setAnchor(0.5, 0.5);
        this._slidesGroups[0].add(this._texts[key]);
    }

    var infotext = madnes_get_json("infotext")["infomenuPages"];

    for(var i in infotext) {

        var x = infotext[i]["position"][0];
        var y = infotext[i]["position"][1];

        var page = infotext[i]["page"];
        var lineHeight0 = infotext[i]["title"] ?  infotext[i]["title"]["lineHeight"] : 0;
        var lineHeight1 = infotext[i]["lineHeight"];

        var style0 = {
            "font": "32px Arial",
            "fill": "#faba41",
            "fontWeight": ""
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": ""
        };

        if(infotext[i]["fontSize"] && infotext[i]["font"])
        {
            style0["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
            style1["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
        }

        /*if(infotext[i]["color"])
        {
            style0["fill"] = infotext[i]["color"];
            style1["fill"] = infotext[i]["color"];
        }*/
        /*if(infotext[i]["bold"])
        {
            if(infotext[i]["bold"] == 1)
            {
                //style0["fontWeight"] = "bold";
                style1["fontWeight"] = "bold";
            }
            else if(infotext[i]["bold"] == 0)
            {
                //style0["fontWeight"] = "";
                style1["fontWeight"] = "";
            }
        }*/

        var line0 = 0;
        var line1 = 0;

        var text = "";

        if(infotext[i]["title"]) {

            if(infotext[i]["title"]["bold"]) {
                style0["fontWeight"] = infotext[i]["title"]["bold"] == 1 ? "bold" : "";
            }

            if(infotext[i]["title"]["color"]) {
                style0["fill"] = infotext[i]["title"]["color"];
            }

            if(infotext[i]["title"]["strokeThickness"] && infotext[i]["title"]["strokeThickness"] * 1 > 1) {
                style0["strokeThickness"] = infotext[i]["title"]["strokeThickness"] / multi ;
            }

            if(infotext[i]["title"]["strokeColor"]) {
                style0["strokeColor"] = infotext[i]["title"]["strokeColor"];
            }

            for(var j in infotext[i]["title"]["content"]) {

                text = infotext[i]["title"]["content"][j];

                var t1 = MI.addText(x, y + line0 * lineHeight0, text, style0/*, textName*/);
                this._slidesGroups[page * 1].add(t1);
                this._objects.push(t1);

                line0++;
            }
        }

        if(infotext[i]["body"]) {
            if(infotext[i]["body"]["bold"]) {
                style1["fontWeight"] = infotext[i]["body"]["bold"] == 1 ? "bold" : "";
            }

            if(infotext[i]["body"]["color"]) {
                style1["fill"] = infotext[i]["body"]["color"];
            }

            for(var j in infotext[i]["body"]["content"])
            {
                text = infotext[i]["body"]["content"][j];

                var t2 = MI.addText(x, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
                this._slidesGroups[page * 1 ].add(t2);
                this._objects.push(t2);
                line1++;
            }
        }
    }

    this._hideAllSlides();
};

GameInfo.prototype.update = function(bet) {

    if(!this._slidesGroups.length) {
        return;
    }

    var symbols = this._serverConfig.getSymbols();
    for(var i = 0; i < symbols.length; i++) {
        var factors = symbols[i]["factors"];
        var name = AbstractSymbol.getSymbolByNum(i);

        for(var factorIdx = 0; factorIdx < factors.length; factorIdx++) {
            var factor = factors[factorIdx];

            if(!factor) {
                factor = 1;
            }

            if(typeof this._texts[name + "_" + (factorIdx + 1)] === 'undefined') {
                continue;
            }

            this._texts[name + "_" + (factorIdx + 1)].setAdjustText(bet * factor, 9999);
        }
    }
};

GameInfo.prototype.open = function() {
    this._show(this._pos);
};

GameInfo.prototype.slideLeft = function() {
    this._slide(-1);
};

GameInfo.prototype.slideRight = function() {
    this._slide(1);
};

/**
 * @private
 * @param {number} dir
 * @returns {undefined}
 */
GameInfo.prototype._slide = function(dir) {

    if(this._locked) {
        return;
    }

    this._locked = true;

    var nextPos = this._pos + dir;

    if(nextPos < 0) {
        nextPos = this._slidesGroups.length - 1;
    }

    if(nextPos >= this._slidesGroups.length) {
        nextPos = 0;
    }

    (function(_this, pos, _slides) {
        MI.addTween().to(_slides[pos], { 'x': wi * dir * -1 }, {
            'duration': _this._slideDuration,
            'callback': function() {
                _slides[pos].setVisible(false);
            }
        });
    } (this, this._pos, this._slidesGroups));


    this._slidesGroups[nextPos].setVisible(true);
    this._slidesGroups[nextPos].setPosX(wi * dir);

    MI.addTween().to(this._slidesGroups[nextPos], { 'x': 0 }, {
        'duration': this._slideDuration,
        'callback': function() {
            this._locked = false;
        }.bind(this)
    });

    this._pos = nextPos;
};

GameInfo.prototype.close = function() {
    this._hideAllSlides();
};

GameInfo.prototype._show = function(slideId) {
    this._hideAllSlides();
    this._slidesGroups[slideId].setPos(0, 0);
    this._slidesGroups[slideId].setVisible(true);
};

GameInfo.prototype._hideAllSlides = function() {
    for(var i = 0; i < this._slidesGroups.length; i++) {
        this._slidesGroups[i].setVisible(false);
    }
};

GameInfo.prototype.destroy = function() {
    for(var i in this._texts) {
        this._texts[i].destroy();
    }
    this._texts.length = 0;

    for(var i = 0; i < this._objects.length; i++) {
        this._objects[i].destroy();
    }
    this._objects.length = 0;
};

GameInfo.prototype.showMain = function() {
    if(this._pos === 0) {
        return;
    }

    if(!this._locked) {
        this._slide(-1, 0);
    } else {
        this._slideCallbackOnce = () => {
            this._slide(-1, 0);
        }
    }
}